import React from 'react';
import '/Users/jilin/projects/antd/rc-dialog/docs/demo/ant-design.md?watch=parent';
import * as docs_demo_ant_design_demo_ant_design_deps_1 from 'react';
import * as docs_demo_ant_design_demo_ant_design_deps_2 from '@rc-component/select';
import * as docs_demo_ant_design_demo_ant_design_deps_3 from '@rc-component/select/assets/index.less';
import * as docs_demo_ant_design_demo_ant_design_deps_4 from '@rc-component/dialog';
import * as docs_demo_ant_design_demo_ant_design_deps_5 from '/Users/jilin/projects/antd/rc-dialog/assets/index.less';
export const demos = {
  'docs-demo-ant-design-demo-ant-design': {
    component: React.memo(React.lazy(() => import( /* webpackChunkName: "demos" */ '/Users/jilin/projects/antd/rc-dialog/docs/examples/ant-design.tsx?techStack=react'))),
    asset: {
  "type": "BLOCK",
  "id": "docs-demo-ant-design-demo-ant-design",
  "refAtomIds": [],
  "dependencies": {
    "index.tsx": {
      "type": "FILE",
      "value": require('/Users/jilin/projects/antd/rc-dialog/docs/examples/ant-design.tsx?dumi-raw').default
    },
    "react": {
      "type": "NPM",
      "value": "18.3.1"
    },
    "@rc-component/select": {
      "type": "NPM",
      "value": "1.1.3"
    },
    "@rc-component/dialog": {
      "type": "NPM",
      "value": "1.5.1"
    },
    "../../assets/index.less": {
      "type": "FILE",
      "value": require('/Users/jilin/projects/antd/rc-dialog/assets/index.less?dumi-raw').default
    }
  },
  "entry": "index.tsx"
},
    context: {
  "../../assets/index.less": docs_demo_ant_design_demo_ant_design_deps_5,
  "react": docs_demo_ant_design_demo_ant_design_deps_1,
  "@rc-component/select": docs_demo_ant_design_demo_ant_design_deps_2,
  "@rc-component/select/assets/index.less": docs_demo_ant_design_demo_ant_design_deps_3,
  "@rc-component/dialog": docs_demo_ant_design_demo_ant_design_deps_4,
  "/Users/jilin/projects/antd/rc-dialog/assets/index.less": docs_demo_ant_design_demo_ant_design_deps_5
},
    renderOpts: {
          
          compile: async (...args) => {
            return (await import('/Users/jilin/projects/antd/rc-dialog/node_modules/dumi/dist/client/misc/reactDemoCompiler.js')).default(...args);
          },
        },
  },
};